<template>
  <!-- Formatting Tools -->
  <div v-if="editor" class="px-4 py-2 text-[15px] leading-[17.78px] !font-Rubik placeholder-gray-400 text-black text-sm border border-b-0 border-borderGray rounded-[2px] w-full" :class="!isEditable && '!py-0 border-[transparent]'">
    <div v-if="isEditable" class="formatting-tools flex items-center flex-wrap text-xs !font-Rubik">
      <button @click="editor.chain().focus().toggleHeading({ level: 1 }).run()" :class="{ 'is-active': editor.isActive('heading', { level: 1 }) }">
        h1
      </button>
      <button @click="editor.chain().focus().toggleHeading({ level: 2 }).run()" :class="{ 'is-active': editor.isActive('heading', { level: 2 }) }">
        h2
      </button>
      <button @click="editor.chain().focus().toggleHeading({ level: 3 }).run()" :class="{ 'is-active': editor.isActive('heading', { level: 3 }) }">
        h3
      </button>
      <button @click="editor.chain().focus().toggleHeading({ level: 4 }).run()" :class="{ 'is-active': editor.isActive('heading', { level: 4 }) }">
        h4
      </button>
      <button @click="editor.chain().focus().toggleHeading({ level: 5 }).run()" :class="{ 'is-active': editor.isActive('heading', { level: 5 }) }">
        h5
      </button>
      <button @click="editor.chain().focus().toggleHeading({ level: 6 }).run()" :class="{ 'is-active': editor.isActive('heading', { level: 6 }) }">
        h6
      </button>
      <button @click="editor.chain().focus().setParagraph().run()" :class="{ 'is-active': editor.isActive('paragraph') }">
        <!-- paragraph -->
        <svg width="16px" height="16px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M19 5H16M11 5H16M11 5V15M11 5L10 5C8.33333 5 5 6 5 10C5 14 8.33333 15 10 15H11M11 19V15M16 19V5" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
        </svg>
      </button>
      <button @click="editor.chain().focus().toggleBulletList().run()" :class="{ 'is-active': editor.isActive('bulletList') }">
        <!-- bullet list -->
        <svg width="16px" height="16px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
          <g id="🔍-Product-Icons" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g id="ic_fluent_text_bullet_list_24_filled" fill="currentColor" fill-rule="nonzero">
              <path d="M3.49941508,15.5005496 C4.32751917,15.5005496 4.99883017,16.1718606 4.99883017,16.9999647 C4.99883017,17.8280688 4.32751917,18.4993798 3.49941508,18.4993798 C2.671311,18.4993798 2,17.8280688 2,16.9999647 C2,16.1718606 2.671311,15.5005496 3.49941508,15.5005496 Z M7.50033615,15.9999647 L21.0034765,15.9999647 C21.5557612,15.9999647 22.0034765,16.44768 22.0034765,16.9999647 C22.0034765,17.5128006 21.6174363,17.9354719 21.1200976,17.993237 L21.0034765,17.9999647 L7.50033615,17.9999647 C6.9480514,17.9999647 6.50033615,17.5522495 6.50033615,16.9999647 C6.50033615,16.4871289 6.88637634,16.0644576 7.38371503,16.0066924 L7.50033615,15.9999647 L21.0034765,15.9999647 L7.50033615,15.9999647 Z M3.49941508,10.5005849 C4.32751917,10.5005849 4.99883017,11.1718959 4.99883017,12 C4.99883017,12.8281041 4.32751917,13.4994151 3.49941508,13.4994151 C2.671311,13.4994151 2,12.8281041 2,12 C2,11.1718959 2.671311,10.5005849 3.49941508,10.5005849 Z M7.50033615,11 L21.0034765,11 C21.5557612,11 22.0034765,11.4477153 22.0034765,12 C22.0034765,12.5128358 21.6174363,12.9355072 21.1200976,12.9932723 L21.0034765,13 L7.50033615,13 C6.9480514,13 6.50033615,12.5522847 6.50033615,12 C6.50033615,11.4871642 6.88637634,11.0644928 7.38371503,11.0067277 L7.50033615,11 L21.0034765,11 L7.50033615,11 Z M3.49941508,5.50702465 C4.32751917,5.50702465 4.99883017,6.17833565 4.99883017,7.00643973 C4.99883017,7.83454382 4.32751917,8.50585482 3.49941508,8.50585482 C2.671311,8.50585482 2,7.83454382 2,7.00643973 C2,6.17833565 2.671311,5.50702465 3.49941508,5.50702465 Z M7.50033615,6.00003528 L21.0034765,6.00003528 C21.5557612,6.00003528 22.0034765,6.44775053 22.0034765,7.00003528 C22.0034765,7.51287112 21.6174363,7.93554245 21.1200976,7.99330755 L21.0034765,8.00003528 L7.50033615,8.00003528 C6.9480514,8.00003528 6.50033615,7.55232003 6.50033615,7.00003528 C6.50033615,6.48719945 6.88637634,6.06452812 7.38371503,6.00676302 L7.50033615,6.00003528 L21.0034765,6.00003528 L7.50033615,6.00003528 Z" id="🎨-Color">
              </path>
            </g>
        </g>
        </svg>
      </button>
      <button @click="editor.chain().focus().toggleOrderedList().run()" :class="{ 'is-active': editor.isActive('orderedList') }">
        <!-- ordered list -->
        <svg width="16px" height="16px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M5.99999 5.5C5.99999 5.22386 5.77613 5 5.49999 5C5.22385 5 4.99999 5.22386 4.99999 5.5V8.5C4.99999 8.77614 5.22385 9 5.49999 9C5.77613 9 5.99999 8.77614 5.99999 8.5V5.5ZM5.25046 11.2673C5.38308 11.1789 5.55766 11.1864 5.68212 11.286C5.85245 11.4223 5.86653 11.6764 5.71228 11.8306L4.39644 13.1464C4.25344 13.2894 4.21066 13.5045 4.28805 13.6913C4.36544 13.8782 4.54776 14 4.74999 14H6.49999C6.77613 14 6.99999 13.7761 6.99999 13.5C6.99999 13.2239 6.77613 13 6.49999 13H5.9571L6.41939 12.5377C6.99508 11.962 6.94256 11.0137 6.30681 10.5051C5.8423 10.1335 5.19072 10.1053 4.69576 10.4352L4.47264 10.584C4.24288 10.7372 4.18079 11.0476 4.33397 11.2773C4.48714 11.5071 4.79758 11.5692 5.02734 11.416L5.25046 11.2673ZM4.74999 15.5C4.47385 15.5 4.24999 15.7239 4.24999 16C4.24999 16.2761 4.47385 16.5 4.74999 16.5H5.29288L4.64644 17.1464C4.50344 17.2894 4.46066 17.5045 4.53805 17.6913C4.61544 17.8782 4.79776 18 4.99999 18H5.74999C5.88806 18 5.99999 18.1119 5.99999 18.25C5.99999 18.3881 5.88806 18.5 5.74999 18.5H4.74999C4.47385 18.5 4.24999 18.7239 4.24999 19C4.24999 19.2761 4.47385 19.5 4.74999 19.5H5.74999C6.44035 19.5 6.99999 18.9404 6.99999 18.25C6.99999 17.6972 6.6412 17.2283 6.1438 17.0633L6.85355 16.3536C6.99654 16.2106 7.03932 15.9955 6.96193 15.8087C6.88454 15.6218 6.70222 15.5 6.49999 15.5H4.74999ZM8.99999 6C8.44771 6 7.99999 6.44772 7.99999 7C7.99999 7.55228 8.44771 8 8.99999 8H19C19.5523 8 20 7.55228 20 7C20 6.44772 19.5523 6 19 6H8.99999ZM8.99999 11C8.44771 11 7.99999 11.4477 7.99999 12C7.99999 12.5523 8.44771 13 8.99999 13H19C19.5523 13 20 12.5523 20 12C20 11.4477 19.5523 11 19 11H8.99999ZM8.99999 16C8.44771 16 7.99999 16.4477 7.99999 17C7.99999 17.5523 8.44771 18 8.99999 18H19C19.5523 18 20 17.5523 20 17C20 16.4477 19.5523 16 19 16H8.99999Z" fill="currentColor"/>
        </svg>
      </button>
      <button @click="editor.chain().focus().toggleStrike().run()" :class="{ 'is-active': editor.isActive('strike') }">
        <!-- strike -->
        <svg fill="currentColor" width="16px" height="16px" viewBox="-5 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 15.25h21.875v1.938h-21.875v-1.938zM11.563 13.25l2 1.063h-7.969c-0.563-0.844-0.906-1.875-0.906-3.031-0.031-3.625 2.781-6.094 7.406-6.094 1.031 0 2.344 0.125 3.625 0.5 0.406 0.125 0.719 0.188 1.094 0.25 0.25 0.719 0.563 2.438 0.563 4.563 0 0-1.219 0.094-1.25 0.094-0.531-1.625-1.906-3.938-4.188-3.938-2.125 0-3.25 1.375-3.25 2.969 0 1.469 1.281 2.781 2.875 3.625zM13.844 22.563c0-2.063-1.563-3.469-3.188-4.438h6.969c0.344 0.75 0.563 1.625 0.563 2.656 0 3.938-3.219 6.469-8.063 6.469-2.906 0-4.75-0.813-5.406-1.188-0.625-0.719-1.031-3-1.031-5.188l1.219-0.094c0.625 2.063 2.781 5 5.5 5 2.344 0 3.438-1.625 3.438-3.219z"></path>
        </svg>
      </button>
      <button @click="editor.chain().focus().toggleCode().run()" :class="{ 'is-active': editor.isActive('code') }">
        <!-- code -->
        <svg width="16px" height="16px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7 8L3 11.6923L7 16M17 8L21 11.6923L17 16M14 4L10 20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      <button @click="editor.chain().focus().setHardBreak().run()">
        <!-- Hard break -->
        <svg fill="currentColor" width="16px" height="16px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path fill-rule="evenodd" d="M7,18.585 L8.29289322,17.2928932 C8.65337718,16.9324093 9.22060824,16.9046797 9.61289944,17.2097046 L9.70710678,17.2928932 C10.0675907,17.6533772 10.0953203,18.2206082 9.79029539,18.6128994 L9.70710678,18.7071068 L6.70710678,21.7071068 L6.663147,21.7485042 L6.59530661,21.8036654 L6.4840621,21.8753288 L6.42309915,21.9063462 L6.34165038,21.9401141 L6.26599297,21.9641549 L6.11747418,21.9931658 L6,22 L5.918,21.996 L5.79927424,21.9797599 L5.68785748,21.9502619 L5.57677845,21.9063266 L5.47929125,21.8540045 L5.4048407,21.8036865 L5.29289322,21.7071068 L2.29289322,18.7071068 C1.90236893,18.3165825 1.90236893,17.6834175 2.29289322,17.2928932 C2.65337718,16.9324093 3.22060824,16.9046797 3.61289944,17.2097046 L3.70710678,17.2928932 L5,18.585 L5,5.415 L3.70710678,6.70710678 L3.61289944,6.79029539 C3.22060824,7.09532028 2.65337718,7.06759074 2.29289322,6.70710678 C1.93240926,6.34662282 1.90467972,5.77939176 2.20970461,5.38710056 L2.29289322,5.29289322 L5.29289322,2.29289322 L5.4048407,2.19631351 L5.47929125,2.14599545 L5.57677845,2.09367336 L5.68785748,2.04973809 L5.79927424,2.02024007 L5.918,2.004 L6,2 L6.11747418,2.00683422 L6.26599297,2.03584514 L6.34165038,2.05988586 L6.42309915,2.09365378 L6.4840621,2.12467117 L6.59530661,2.19633458 L6.663147,2.2514958 L6.70710678,2.29289322 L9.70710678,5.29289322 L9.79029539,5.38710056 C10.0699015,5.74670083 10.0699015,6.25329917 9.79029539,6.61289944 L9.70710678,6.70710678 L9.61289944,6.79029539 C9.25329917,7.06990154 8.74670083,7.06990154 8.38710056,6.79029539 L8.29289322,6.70710678 L7,5.415 L7,18.585 Z M21,19 C21.5522847,19 22,19.4477153 22,20 C22,20.5522847 21.5522847,21 21,21 L13,21 C12.4477153,21 12,20.5522847 12,20 C12,19.4477153 12.4477153,19 13,19 L21,19 Z M21,11 C21.5522847,11 22,11.4477153 22,12 C22,12.5522847 21.5522847,13 21,13 L13,13 C12.4477153,13 12,12.5522847 12,12 C12,11.4477153 12.4477153,11 13,11 L21,11 Z M21,3 C21.5522847,3 22,3.44771525 22,4 C22,4.55228475 21.5522847,5 21,5 L13,5 C12.4477153,5 12,4.55228475 12,4 C12,3.44771525 12.4477153,3 13,3 L21,3 Z"/>
        </svg>
      </button>
      <button @click="editor.chain().focus().unsetAllMarks().run()">
        clear marks
      </button>
      <button @click="editor.chain().focus().clearNodes().run()">
        clear nodes
      </button>
    </div>
    <bubble-menu
      class="bubble-menu"
      :tippy-options="{ duration: 100 }"
      :editor="editor"
    >
      <button @click="editor.chain().focus().toggleBold().run()" :class="{ 'is-active': editor.isActive('bold') }">
        Bold
      </button>
      <button @click="editor.chain().focus().toggleItalic().run()" :class="{ 'is-active': editor.isActive('italic') }">
        Italic
      </button>
      <button @click="editor.chain().focus().toggleStrike().run()" :class="{ 'is-active': editor.isActive('strike') }">
        Strike
      </button>
    </bubble-menu>

    <floating-menu
      class="floating-menu"
      :tippy-options="{ duration: 100 }"
      :editor="editor"
    >
      <button @click="editor.chain().focus().toggleHeading({ level: 1 }).run()" :class="{ 'is-active': editor.isActive('heading', { level: 1 }) }">
        H1
      </button>
      <button @click="editor.chain().focus().toggleHeading({ level: 2 }).run()" :class="{ 'is-active': editor.isActive('heading', { level: 2 }) }">
        H2
      </button>
      <button @click="editor.chain().focus().toggleBulletList().run()" :class="{ 'is-active': editor.isActive('bulletList') }">
        Bullet List
      </button>
    </floating-menu>
  </div>
  <!-- Editor -->
  <div class="editor-wrapper px-4 py-4 text-[15px] leading-[17.78px] !font-Rubik placeholder-gray-400 text-black text-sm border border-borderGray rounded-[6px] w-full focus:outline-none focus:border-black hover:border-black focus:ring-0" :class="!isEditable && '!text-greyText !hover:border-greyText !focus:border-greyText cursor-not-allowed'">
    <editor-content :editor="editor" :editable="isEditable" />
  </div>

</template>

<script>
import StarterKit from '@tiptap/starter-kit'
// import Code from '@tiptap/extension-code'
// import Document from '@tiptap/extension-document'
// import Paragraph from '@tiptap/extension-paragraph'
// import Text from '@tiptap/extension-text'
import Typography from '@tiptap/extension-typography'
import {
  Editor, EditorContent,
  BubbleMenu,
  FloatingMenu
} from '@tiptap/vue-3'
import Placeholder from '@tiptap/extension-placeholder'

import { ColorHighlighter } from '../utils/wysiwygTools/ColorHighlighter.js'
import { SmileyReplacer } from '../utils/wysiwygTools/SmileyReplacer.js'

export default {
  components: {
    EditorContent,
    BubbleMenu,
    FloatingMenu
  },

  props: {
    modelValue: {
      type: String,
      default: ''
    },
    isEditable: {
      type: Boolean,
      default: true
    }
  },

  emits: ['update:modelValue'],

  data () {
    return {
      editor: null,
      editable: this.isEditable
    }
  },

  watch: {
    modelValue (value) {
      // HTML
      const isSame = this.editor.getHTML() === value

      // JSON
      // const isSame = JSON.stringify(this.editor.getJSON()) === JSON.stringify(value)

      if (isSame) {
        return
      }

      this.editor.commands.setContent(value, false)
    }
  },

  mounted () {
    this.editor = new Editor({
      extensions: [
        StarterKit,
        Typography,
        ColorHighlighter,
        SmileyReplacer,
        Placeholder.configure({ placeholder: 'Type something...' })
      ],
      content: this.modelValue,
      editable: this.editable,
      editorProps: {
        attributes: {
          spellcheck: 'false'
        }
      },
      onUpdate: () => {
        // HTML
        this.$emit('update:modelValue', this.editor.getHTML())

        // JSON
        // this.$emit('update:modelValue', this.editor.getJSON())
      }
    })
  },

  beforeUnmount () {
    this.editor.destroy()
  }
}
</script>

<style>
.tiptap p.is-editor-empty:first-child::before {
  content: attr(data-placeholder);
  float: left;
  color: #adb5bd;
  pointer-events: none;
  height: 0;
}
.tiptap > * + * {
  margin-top: 0.75em;
}

.tiptap:focus-visible {
  outline: none;
}

.tiptap ul {
  list-style-type: disc;
}
.tiptap ol {
  list-style-type: revert;
}

.tiptap ul,
.tiptap ol {
  padding: 0 1rem;
  display: block;
  margin-block-start: 1em;
  margin-block-end: 1em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  padding-inline-start: 20px;
}
.tiptap h1 {
  font-size: 2em;
}
.tiptap h2 {
  font-size: 1.5em;
}
.tiptap h3 {
  font-size: 1.17em;
}
.tiptap h4 {
  font-size: 1em;
}
.tiptap h5 {
  font-size: 0.83em;
}
.tiptap h6 {
  font-size: 0.67em;
}
.tiptap h1,
.tiptap h2,
.tiptap h3,
.tiptap h4,
.tiptap h5,
.tiptap h6 {
  line-height: 1.1;
  font-weight: bold;
}

.tiptap pre {
  background: #0D0D0D;
  color: #FFF;
  font-family: 'JetBrainsMono', monospace;
  padding: 0.75rem 1rem;
  border-radius: 0.5rem;
}

.tiptap blockquote {
  padding-left: 1rem;
  border-left: 2px solid rgba(13, 13, 13, 0.1);
}

.tiptap hr {
  margin: 1rem 0;
}

.bubble-menu {
  display: flex;
  background-color: #0D0D0D;
  padding: 0.2rem;
  border-radius: 0.5rem;
}

.bubble-menu button {
  border: none;
  background: none;
  color: #FFF;
  font-size: 0.85rem;
  font-weight: 500;
  padding: 0 0.2rem;
  opacity: 0.6;
}

.bubble-menu button:hover,
.bubble-menu button.is-active {
  opacity: 1;
}

.floating-menu {
  display: flex;
  background-color: rgba(13, 13, 13, 0.1);
  padding: 0.2rem;
  border-radius: 0.5rem;
}

.floating-menu button {
  border: none;
  background: none;
  font-size: 0.85rem;
  font-weight: 500;
  padding: 0 0.2rem;
  opacity: 0.6;
}

.floating-menu button:hover,
.floating-menu button.is-active {
  opacity: 1;
}

.formatting-tools button {
  background-color: transparent;
  border: solid 1px rgb(108, 108, 108);
  color: black;
  padding: 4px 6px;
  margin: 2px;
  border-radius: 4px;
}
.formatting-tools button.is-active {
  background-color: black;
  border: 1px solid transparent;
  color: white;
}

</style>
